import store from '@/store'

import orderService from '@/services/order'

const actions = {
  newOrder() {
    return new Promise(async (resolve, reject) => {
      try {
        const idStore = store.get('shop/shop.id')
        const client = store.get('cart/client')
        const billingInfo = store.get('cart/billingInfo')
        const shippingInfo = store.get('cart/address')
        const products = [...store.get('cart/productsInCart')]
        const appliedCoupon = store.get('coupons/appliedCoupon')

        const items = products.map(product => ({
          id: product.id,
          quantity: product.quantity,
          finalPrice: product.finalPrice,
          finalPriceBeforeDiscounts: product.finalPriceBeforeDiscounts,
          originalPrice: product.price,
          discounts: product.discounts,
          taxes: product.taxes
        }))

        const data = {
          client,
          shippingMethod: {
            id: store.get('cart/shippingMethod.id')
          },
          paymentMethod: {
            id: store.get('cart/paymentMethod.id')
          },
          shippingInfo,
          items,
          discountCoupon: {}
        }

        if (billingInfo) {
          data.billingInfo = billingInfo
        }

        if (appliedCoupon?.id) {
          data.discountCoupon.id = appliedCoupon.id
        }

        const { order } = await orderService.newOrder(idStore, data)

        // Preservar los precios que el usuario vio en el carrito para mantener consistencia
        const itemsWithPreservedPrices = order.items.map(orderItem => {
          // Convertir IDs a string para comparación segura
          const originalCartProduct = products.find(p => String(p.id) === String(orderItem.id))

          if (originalCartProduct && originalCartProduct.finalPrice !== undefined) {
            return {
              ...orderItem,
              finalPrice: originalCartProduct.finalPrice,
              finalPriceBeforeDiscounts: originalCartProduct.finalPriceBeforeDiscounts,
              // Preservar propiedades críticas para el priceCalculator
              discounts: originalCartProduct.discounts,
              taxes: originalCartProduct.taxes,
              // Preservar propiedades heredadas para variantes
              name: originalCartProduct.name,
              category: originalCartProduct.category,
              idVariantParent: originalCartProduct.idVariantParent
            }
          }
          return orderItem
        })

        // Actualizar la orden con precios preservados para consistencia total
        const orderWithPreservedPrices = {
          ...order,
          items: itemsWithPreservedPrices
        }

        store.set('order/lastOrder', orderWithPreservedPrices)
        store.set('cart/lastOrderProductsInCart', itemsWithPreservedPrices)
        store.dispatch('cart/cleanCart')

        resolve(orderWithPreservedPrices)
      } catch (e) {
        store.dispatch('notification/showDangerNotification', {
          text: 'Error creando tu pedido, puedes intentar de nuevo en unos minutos.'
        })
        reject(e)
      }
    })
  },
  getOrder(context, { idOrder, extraAttrs }) {
    const idStore = store.get('shop/shop.id')
    return orderService
      .getOrder(idStore, idOrder, extraAttrs)
      .then(res => {
        if (res && res.order) {
          return res.order
        }
        return false
      })
      .catch(e => e)
  },
  getPayment(context, { idPayment }) {
    const idStore = store.get('shop/shop.id')
    return orderService
      .getPayment(idStore, idPayment)
      .then(res => {
        if (res && res.payment) {
          return res.payment
        }
        return false
      })
      .catch(e => e)
  },
  regretOrder(context, { orderNumber, email }) {
    const idStore = store.get('shop/shop.id')
    return orderService
      .regretOrder(idStore, { orderNumber, email })
      .then(res => {
        if (res) {
          store.set('order/idCancelRequest', res.idCancelRequest)
          return res
        }
        return false
      })
      .catch(e => e)
  }
}

export default actions
